import service from "@/api/service";
import { GetResponse } from "@/api/shiten-list/response";
import { GetRequest } from "@/api/shiten-list/request";

/**
 * プッシュメッセージ配信対象店舗取得APIをコールします。
 *
 * @return GetResponse
 */
export async function get(getRequest: GetRequest) {
  const response = await service.post("/get-shiten-list", getRequest);
  return response.data as GetResponse;
}
